module.exports = __webpack_public_path__ + "static/media/3_fruit_cupcake.c61f4ee6.jpg";